module.exports = __webpack_public_path__ + "static/img/iphone-share.515f89d0.png";